import React, {useMemo} from "react";
import {
	FormControl,
	Select,
	MenuItem,
	Tooltip,
	Button,
	Grid,
} from "@mui/material";
import { formatCurrency } from "../../../utils/FormatCurrency";

const BookOptions = (props: any) => {
	const {
		selectedClass,
		quantity,
		bookFor,
		setBookFor,
		clubData,
		userConfig,
	} = props;

	const allUsers = useMemo(() => {
		const currentUser = { id: userConfig?.clientId, fullName: userConfig?.fullName };
		if (!props.purchaseForUsers) {
			return [currentUser]
		}	
		const ids = props.purchaseForUsers?.map((user: any) => user.id) || [];
		const users = ids.includes(userConfig?.clientId)
			? props.purchaseForUsers
			: [currentUser, ...props.purchaseForUsers];

		return users?.map((item: any) => (
			<MenuItem key={item.id} value={item.id}>
				{item.fullName}
			</MenuItem>
		))

	}, [userConfig.clientId, props.purchaseForUsers]);

	return (
		<Grid container>
			<Grid size={{xs: 4}} sx={{ mt: 1 }}>
				{selectedClass.name}
			</Grid>
			<Grid size={{xs: 4}} sx={{ textAlign: { xs: "left" } }}>
				<Grid size={{xs: 3, sm: 4}}>
					<FormControl
						sx={{ mt: 0, maxWidth: { xs: 100, sm: 180 }, minWidth: 100 }}
						margin="dense"
					>
						<Select
							size="small"
							fullWidth
							name="bookFor"
							margin="none"
							onChange={(event: any) => setBookFor(event.target.value)}
							value={bookFor}
							variant="outlined"
							color="secondary"
						>
							{allUsers}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
			<Grid size={{xs: 2}} sx={{ mt: 1, textAlign: { xs: "left" } }}>
				{formatCurrency(selectedClass.amount, clubData)}
				{selectedClass.defaultRenewal && (
					<Tooltip arrow placement="top" title="Auto Renewal">
						<Button sx={{ padding: 0.2, minHeight: 0.2, minWidth: 0.2 }}>
							R
						</Button>
					</Tooltip>
				)}
			</Grid>
			<Grid size={{xs: 2}} sx={{ mt: 1, textAlign: "right" }}>
				{quantity}
			</Grid>
		</Grid>
	);
};

export default BookOptions;
